import { useQuery } from "react-query";
import axiosInstance from "./axiosInstance";
import { SearchMessageRes } from "../../types/ResType";
import { useAppSelector } from "../../utils/hooks";

export const useSearchMessages = (searchText: string) => {
  const currentConversationData = useAppSelector(
    (state) => state.CurrentConversation
  );

  return useQuery<SearchMessageRes, Error>(
    ["chat/search-message", searchText, currentConversationData.chat_id],
    async () => {
      const response = await axiosInstance.post<SearchMessageRes>(
        "chat/search-message",
        {
          search_text: searchText,
          chat_id: currentConversationData.chat_id,
        }
      );

      return response.data;
    },
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: currentConversationData.chat_id > 0 && searchText.length > 0,
    }
  );
};
